import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import Input from "../input/Input";
import Label from "../other/label";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import {
  setOccupationType,
  setBusinessType,
  setOrganizationName,
  setAddress,
  setDesignation,
  setIdNo,
  setFinancialDetails,
  setSecurtitesTrading,
  setCompanyName,
  setCompanyDesignation,
  addCompanyDetails,
  removeCompanyDetails,
  setCompanyDesignationDesc,
  setFinancialDetailsDesc,
  setOccupationTypeError,
  setBusinessTypeError,
  setOrganizationNameError,
  setAddressError,
  setDesignationError,
  setIdNoError,
  setFinancialDetailsError,
  setOccupationTypeOthers,
  setBusinessTypeOthers,
  setDesignationOthers,
  setOccupationTypeDesc,
  clearCompanyDetails,
  setCompanyNameOrRelation,
  setCompanyNameRelation,
  setCompanyRelationDesignation,
  setCompanyRelationDesignationDesc,
  setRelationDesignationOthers,
  setFromAD, setToAD, addCompanyRelationDetails,
  clearCompanyRelationDetails,
  removeCompanyRelationDetails,
  setOccupationTypeOthersError,
  setBusinessTypeOthersError,
  setDocIdError,
  setCompanyNameOrRelationError,
  setCompanyNameRelationError,
  setRelationDesignationOthersError,
  setCompanyRelationDesignationError,

} from "../../redux/occupationSlice";
import { useState, useEffect, useRef } from "react";
import ApiService from "../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NextButton, PrevButton } from "./kycSidebar";
import { classNames } from "primereact/utils";
import { DynamicFieldSection } from "./personalDetails";
import { SaveButton } from "./declerationDetails";
import { useToast } from "../other/Toast";
import { getTValue } from "../other/label";
import InputText from "../other/InputText";
import LookupService from "../service/lookupService";
import { setDesignationList } from "../../redux/lookupSlice";
import { confirmDialog } from "primereact/confirmdialog";
import AdBsDatePicker from "../other/adBsDatePicker";
import { alphabetChecker, alphanumericCheck } from "../../helper/validationHelper";

const footer = () => (
  <div class=" p-field p-col-12 p-md-12">
    <div
      className="p-grid"
      style={{ display: "flex", flex: 3.5, padding: "0 10px" }}
    >
      <div style={{ flex: 1 }}>
        <PrevButton />
      </div>
      <div style={{ flex: 1.5 }}>
        <center>
          <SaveButton />
        </center>
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <NextButton />
        </center>
      </div>
    </div>
  </div>
  // <div className="p-grid">
  //   <div className="p-col-12 p-md-5">
  //     <PrevButton />
  //   </div>
  //   <div className="p-col-12 p-md-2">
  //     <SaveButton />
  //   </div>
  //   <div className="p-col-12 p-md-3"></div>
  //   <div className="p-col-12 p-md-2">
  //     <NextButton />
  //   </div>
  // </div>
);

// const occupationTypeList = [
//   {
//     id: 1,
//     descEng: "Service Government",
//     descNep: "सेवा सरकारी",
//   },
//   {
//     id: 2,
//     descEng: "Public/Private Sector",
//     descNep: "सार्वजनिक/निजी क्षेत्र",
//   },
//   {
//     id: 3,
//     descEng: "Others",
//     descNep: "अन्य",
//   },
// ];

// const businessTypeList = [
//   {
//     id: 1,
//     code: 'A',
//     descEng: "Manufacturing",
//     descNep: "उत्पादन",
//   },
//   {
//     id: 2,
//     descEng: "Service Oriented",
//     descNep: "सेवामुखी",
//   },
//   {
//     id: 3,
//     descEng: "Others",
//     descNep: "अन्य",
//   },
// ];

function OccupationDetails() {
  const { t, i18n } = useTranslation();
  const toast = useToast();
  const occupationType = useSelector(
    (state) => state.occupationDetails.occupationType
  );
  const businessType = useSelector(
    (state) => state.occupationDetails.businessType
  );
  const organizationName = useSelector(
    (state) => state.occupationDetails.organizationName
  );
  const occupationTypeOthers = useSelector(
    (state) => state.occupationDetails.occupationTypeOthers
  );
  const businessTypeOthers = useSelector(
    (state) => state.occupationDetails.businessTypeOthers
  );
  const designationOthers = useSelector(
    (state) => state.occupationDetails.designationOthers
  );

  const address = useSelector((state) => state.occupationDetails.address);
  const designation = useSelector(
    (state) => state.occupationDetails.designation
  );
  const docId = useSelector((state) => state.occupationDetails.docId);
  const financialDetails = useSelector(
    (state) => state.occupationDetails.financialDetails
  );
  const securtitesTrading = useSelector(
    (state) => state.occupationDetails.securtitesTrading
  );
  const companyName = useSelector(
    (state) => state.occupationDetails.companyName
  );
  const companyDesignation = useSelector(
    (state) => state.occupationDetails.companyDesignation
  );
  const companyDesignationDesc = useSelector(
    (state) => state.occupationDetails.companyDesignationDesc
  );
  const occupationTypeDesc = useSelector(
    (state) => state.occupationDetails.occupationTypeDesc
  );
  const companyNameOrRelation = useSelector(
    (state) => state.occupationDetails.companyNameOrRelation
  );
  const companyNameRelation = useSelector(
    (state) => state.occupationDetails.companyNameRelation
  );
  const companyRelationDesignation = useSelector(
    (state) => state.occupationDetails.companyRelationDesignation
  );
  const companyRelationDesignationDesc = useSelector(
    (state) => state.occupationDetails.companyRelationDesignationDesc
  );
  const companyRelationDesignationOthers = useSelector(
    (state) => state.occupationDetails.companyRelationDesignationOthers
  );
  const fromAd = useSelector((state) => state.occupationDetails.fromAd);

  const toAd = useSelector((state) => state.occupationDetails.toAd);

  const [compDesignationDesc, setCompDesignationDesc] = useState();
  const [loadingo, setLoadingo] = useState(false);
  const [loadingd, setLoadingd] = useState(false);

  const errorObj = useSelector((state) => state.occupationDetails.errors);
  let {
    occupationTypeError,
    companyNameOrRelationError,
    companyNameRelationError,
    businessTypeError,
    organizationNameError,
    addressError,
    designationError,
    docIdError,
    financialDetailsError,
    dateError
  } = {};
  if (errorObj && errorObj.occupationTypeError) {
    occupationTypeError = errorObj.occupationTypeError.message;
  }
  if (errorObj && errorObj.businessTypeError) {
    businessTypeError = errorObj.businessTypeError.message;
  }
  if (errorObj && errorObj.organizationNameError) {
    organizationNameError = errorObj.organizationNameError.message;
  }
  if (errorObj && errorObj.companyNameOrRelationError) {
    companyNameOrRelationError = errorObj.companyNameOrRelationError.message;
  }
  if (errorObj && errorObj.companyNameRelationError) {
    companyNameRelationError = errorObj.companyNameRelationError.message;
  }
  if (errorObj && errorObj.addressError) {
    addressError = errorObj.addressError.message;
  }
  if (errorObj && errorObj.designationError) {
    designationError = errorObj.designationError.message;
  }
  if (errorObj && errorObj.docIdError) {
    docIdError = errorObj.docIdError.message;
  }
  if (errorObj && errorObj.financialDetailsError) {
    financialDetailsError = errorObj.financialDetailsError.message;
  }


  const dispatch = useDispatch();

  const [financialDetailsList, setFinancialDetailsList] = useState([]);
  // const [designationList, setDesignationList] = useState([]);
  const companyDetailsList =
    useSelector((state) => state.occupationDetails.companyDetailsList) || [];
  const companyRelationDetailsList =
    useSelector((state) => state.occupationDetails.companyRelationDetailsList) || [];
  const [occupationTypeList, setOccupationTypeList] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);

  const lookupDesignationList = useSelector(
    (state) => state.lookupDetails.designationList
  );

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  useEffect(() => {
    setLoadingo(true);
    setLoadingd(true);
    ApiService.getFinancialDetailsList().then((response) => {
      console.log(response.data);
      setFinancialDetailsList(response.data.data);
      console.log(financialDetailsList);
    });

    ApiService.getDesignationList().then((response) => {
      console.log(response.data);
      setDesignationList(response.data.data);
    }).finally(() => setLoadingd(false));

    ApiService.getOccupationTypeList().then((response) => {
      console.log(response.data);
      setOccupationTypeList(response.data.data);
      console.log(occupationTypeList);
    }).finally(() => setLoadingo(false));

    ApiService.getBusinessTypeList().then((response) => {
      console.log(response.data);
      setBusinessTypeList(response.data.data);
      console.log(businessTypeList);
    });
    if (!lookupDesignationList) {
      LookupService.getDesignationList(dispatch);
    }
  }, []);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    // console.log("aaaman", errors);
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const displayConfirmModal = (param) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => dispatch(removeCompanyDetails(param)),
    });
  };
  const displayConfirmModalRelation = (param) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => dispatch(removeCompanyRelationDetails(param)),
    });
  };

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-briefcase" /> {t("occupationDetails")}
        </h3>
      }
      footer={footer}
    >

      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        <div
          className={
            "p-field p-col-12" +
            (occupationType !== "O" ? " p-md-12" : " p-md-8 stick-right")
          }
        >
          <label className="p-col-12 p-md-12" htmlFor="occupationType">
            {t("occupationType")}*
          </label>
          <Controller
            name="occupationType"
            control={control}
            rules={{ required: "Occupation Type is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={occupationType}
                filter showClear
                disabled={loadingo}
                dropdownIcon={loadingo ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  dispatch(setOccupationType(e.value));
                  field.onChange(e.value);
                  dispatch(
                    setOccupationTypeDesc(
                      e.originalEvent.nativeEvent.target.ariaLabel
                    )
                  );
                  if (e.value !== "O") {
                    dispatch(setOccupationTypeOthers(null));
                  }
                }}
                options={occupationTypeList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("occupationType")}
                optionValue="code"
              />
            )}
          />
          {/* <div className="p-field-radiobutton p-col-12 p-md-12">

            {occupationTypeList.map((occupation) => (
              <div key={occupation.code}>
                <label>
                  <Controller
                    name="occupationType"
                    control={control}
                    rules={{ required: "Occupation Type is required." }}
                    render={({ field, fieldState }) => (
                      <RadioButton
                        id={field.name}
                        {...field}
                        value={occupation.code}
                        onChange={(e) => {
                          dispatch(setOccupationType(e.value));
                          if (e.value !== "O") {
                            dispatch(setOccupationTypeOthers(null));
                          }
                        }}
                        checked={occupationType === occupation.code}
                        className={
                          (classNames({ "p-invalid": fieldState.invalid }),
                            "")
                        }
                      />
                    )}
                  />
                  <Label
                    text={occupation.descEng}
                    textNep={occupation.descNep}
                  />
                </label>
              </div>
            ))}

          </div> */}
          <span style={{ color: "red" }}>{occupationTypeError}</span>
        </div>
        {getFormErrorMessage("occupationType")}
        {occupationType === "O" ? (
          <>
            <div className="p-field p-col-12 p-md-4 stick-left">
              <label
                className="p-col-12 p-md-12"
                htmlFor="occupationTypeOthers"
              >
                {t("occupationTypeOthers")}
              </label>
              <div className="p-inputgroup">
                {/* <Input
                  value={occupationTypeOthers}
                  onChange={(e) => {
                    dispatch(setOccupationTypeOthers(e.target.value));
                  }}
                  placeholder={t("occupationTypeOthers")}
                /> */}
                <Input
                  value={occupationTypeOthers}
                  onChange={(e) => {
                    dispatch(setOccupationTypeOthers(e.target.value));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value.trim(); // Trim to handle whitespace-only values
                    if (!value) {
                      dispatch(setOccupationTypeOthersError({
                        message: "Occupation Type Others can't be empty.",
                        section: "OD",
                      }));
                    }
                    else if (!alphabetChecker(value)) {
                      dispatch(setOccupationTypeOthersError({
                        message: "Occupation type others should be in alphabet characters only.",
                        section: "OD",
                      }));
                    }
                    else {
                      dispatch(setOccupationTypeOthersError({
                        message: null,
                        section: "OD",
                      }));
                    }
                  }}
                  placeholder={t("occupationTypeOthers")}
                />
              </div>
            </div>
          </>
        ) : null}
        <div
          className={
            "p-field p-col-12 " +
            (businessType === "O" ? "p-md-8 stick-right" : "p-md-12")
          }
        >
          <label className="p-col-12 p-md-12" htmlFor="businessType">
            {t("businessType")}
          </label>
          <div className="p-field-radiobutton p-col-12 p-md-12">
            {businessTypeList.map((business) => (
              <div key={business.code}>
                <label htmlFor={business.code}>
                  <Controller
                    name="busineeType"
                    control={control}
                    rules={{ required: "Business Type is required." }}
                    render={({ field, fieldState }) => (
                      <RadioButton
                        id={field.name}
                        {...field}
                        value={business.code}
                        onChange={(e) => {
                          dispatch(setBusinessType(e.value));
                          if (e.value !== "O") {
                            dispatch(setBusinessTypeOthers(null));
                          }
                        }}
                        checked={businessType === business.code}
                        className={
                          (classNames({ "p-invalid": fieldState.invalid }),
                            "p-ml-2 p-mr-2")
                        }
                      />
                    )}
                  />
                  <Label text={business.descEng} textNep={business.descNep} />
                </label>
              </div>
            ))}
          </div>
          <span style={{ color: "red" }}>{businessTypeError}</span>
        </div>
        {getFormErrorMessage("businessType")}
        {businessType === "O" ? (
          <>
            <div className="p-field p-col-12 p-md-4 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="businessTypeOthers">
                {t("businessTypeOthers")}
              </label>
              <div className="p-inputgroup">
                {/* <Input
                  value={businessTypeOthers}
                  onChange={(e) => {
                    dispatch(setBusinessTypeOthers(e.target.value));
                  }}
                  placeholder={t("businessTypeOthers")}
                /> */}
                <Input
                  value={businessTypeOthers}
                  onChange={(e) => {
                    dispatch(setBusinessTypeOthers(e.target.value));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value.trim(); // Trim to handle whitespace-only values
                    if (!value) {
                      dispatch(setBusinessTypeOthersError({
                        message: "Business Type Others can't be empty.",
                        section: "OD",
                      }));
                    }
                    else if (!alphabetChecker(value)) {
                      dispatch(setBusinessTypeOthersError({
                        message: "Business type others should be in alphabet characters only.",
                        section: "OD",
                      }));
                    }
                    else {
                      dispatch(setBusinessTypeOthersError({
                        message: null,
                        section: "OD",
                      }));
                    }
                  }}
                  placeholder={t("businessTypeOthers")}
                />
              </div>
            </div>
          </>
        ) : null}
        <div className="p-field p-col-12 p-md-6 stick-right">
          <label className="p-col-12 p-md-6" htmlFor="organizationName">
            {t("organizationName")}
          </label>
          <Controller
            name="organizationName"
            control={control}
            rules={{ required: "Organization Name is required." }}
            render={({ field, fieldState }) => (
              // <InputText
              //   id={field.name}
              //   {...field}
              //   keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
              //   clearSpace
              //   placeholder={t("organizationName")}
              //   onChange={(e) => dispatch(setOrganizationName(e.target.value))}
              //   value={organizationName}
              //   className={classNames({ "p-invalid": fieldState.invalid })}
              // />
              <InputText
                id={field.name}
                {...field}
                keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                clearSpace
                placeholder={t("organizationName")}
                onChange={(e) => dispatch(setOrganizationName(e.target.value))}
                onBlur={(e) => {
                  const value = e.target.value.trim(); // Trim to handle whitespace-only values
                  if (!value) {
                    dispatch(setOrganizationNameError({
                      message: "Organization's name can't be empty.",
                      section: "OD",
                    }));
                  }
                  else if (!alphabetChecker(value)) {
                    dispatch(setOrganizationNameError({
                      message: "Organization's name should be in alphabet characters only.",
                      section: "OD",
                    }));
                  }
                  else {
                    dispatch(setOrganizationNameError({
                      message: null,
                      section: "OD",
                    }));
                  }
                }}
                value={organizationName}
                className={classNames({ "p-invalid": fieldState.invalid })}
              />
            )}
          />
          <span style={{ color: "red" }}>{organizationNameError}</span>
        </div>
        {getFormErrorMessage("organizationName")}

        <div className="p-field p-col-12 p-md-6 stick-left">
          <label className="p-col-12 p-md-6" htmlFor="address">
            {t("address")}
          </label>
          <Controller
            name="address"
            control={control}
            rules={{ required: "Address is required." }}
            render={({ field, fieldState }) => (
              // <InputText
              //   id={field.name}
              //   {...field}
              //   clearSpace
              //   keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
              //   placeholder={t("address")}
              //   onChange={(e) => dispatch(setAddress(e.target.value))}
              //   value={address}
              //   className={classNames({ "p-invalid": fieldState.invalid })}
              // />
              <InputText
                id={field.name}
                {...field}
                clearSpace
                keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                placeholder={t("address")}
                onChange={(e) => dispatch(setAddress(e.target.value))}
                onBlur={(e) => {
                  const value = e.target.value.trim(); // Trim to handle whitespace-only values
                  if (!value) {
                    dispatch(setAddressError({
                      message: "Organization's Address can't be empty.",
                      section: "OD",
                    }));
                  }
                  else if (!alphabetChecker(value)) {
                    dispatch(setAddressError({
                      message: "Organization's Address should be in alphabet characters only.",
                      section: "OD",
                    }));
                  }
                  else {
                    dispatch(setAddressError({
                      message: null,
                      section: "OD",
                    }));
                  }
                }}
                value={address}
                className={classNames({ "p-invalid": fieldState.invalid })}
              />
            )}
          />
          <span style={{ color: "red" }}>{addressError}</span>
        </div>
        {getFormErrorMessage("address")}

        <div className="p-field p-col-12 p-md-6 stick-right">
          <label className="p-col-12 p-md-6" htmlFor="designation">
            {t("designation")}
          </label>
          <Controller
            name="designation"
            control={control}
            rules={{ required: "Designation is required." }}
            render={({ field, fieldState }) => (
              // <InputText
              //   id={field.name}
              //   {...field}
              //   placeholder={t("designation")}
              //   onChange={(e) => dispatch(setDesignation(e.target.value))}
              //   value={designation}
              //   clearSpace
              //   keyfilter={/^[a-zA-Z0-9\.\- ]$/}
              //   className={classNames({ "p-invalid": fieldState.invalid })}
              // />
              <InputText
                id={field.name}
                {...field}
                placeholder={t("designation")}
                onChange={(e) => dispatch(setDesignation(e.target.value))}
                onBlur={(e) => {
                  const value = e.target.value.trim(); // Trim to handle whitespace-only values
                  if (!value) {
                    dispatch(setDesignationError({
                      message: "Designation can't be empty.",
                      section: "OD",
                    }));
                  }
                  else if (!alphabetChecker(value)) {
                    dispatch(setDesignationError({
                      message: "Designation should be in alphabet characters only.",
                      section: "OD",
                    }));
                  }
                  else {
                    dispatch(setDesignationError({
                      message: null,
                      section: "OD",
                    }));
                  }
                }}
                value={designation}
                clearSpace
                keyfilter={/^[a-zA-Z0-9\.\- ]$/}
                className={classNames({ "p-invalid": fieldState.invalid })}
              />
            )}
          />
          <span style={{ color: "red" }}>{designationError}</span>
        </div>

        {getFormErrorMessage("designation")}
        <div className="p-field p-col-12 p-md-6 stick-left">
          <label className="p-col-12 p-md-6" htmlFor="employeeId">
            {t("employeeId")}
          </label>
          <Controller
            name="employeeId"
            control={control}
            rules={{ required: "Employee Id is required." }}
            render={({ field, fieldState }) => (
              // <Input
              //   id={field.name}
              //   {...field}
              //   placeholder={t("employeeId")}
              //   onChange={(e) => dispatch(setIdNo(e.target.value))}
              //   value={docId}
              //   className={classNames({ "p-invalid": fieldState.invalid })}
              // />
              <Input
                id={field.name}
                {...field}
                placeholder={t("employeeId")}
                onChange={(e) => dispatch(setIdNo(e.target.value))}
                onBlur={(e) => {
                  const value = e.target.value.trim(); // Trim to handle whitespace-only values
                  if (!value) {
                    dispatch(setDocIdError({
                      message: "Employee Id can't be empty.",
                      section: "OD",
                    }));
                  }
                  else if (!alphanumericCheck(value)) {
                    dispatch(setDocIdError({
                      message: "Employee Id should be in alphanumeric characters only.",
                      section: "OD",
                    }));
                  }
                  else {
                    dispatch(setDocIdError({
                      message: null,
                      section: "OD",
                    }));
                  }
                }}
                value={docId}
                keyfilter={/^[a-zA-Z0-9]+$/}  // Added this line to ensure only alphanumeric characters
                className={classNames({ "p-invalid": fieldState.invalid })}
              />
            )}
          />
          <span style={{ color: "red" }}>{docIdError}</span>
        </div>

        {getFormErrorMessage("employeeId")}
        <div className="p-field p-col-12 p-md-12 ">
          <label className="p-col-12 p-md-12" htmlFor="financialDetails">
            {t("financialDetails")}*
          </label>
          <div className=" p-col-12 p-md-12  nepali-font" style={{
            borderRadius: '0px',
            display: 'flex',
            alignItems: 'center',
            margin: '0px',
            marginTop: '0px',
            border: '1px solid #ced4da',
            padding: '0.63rem',
          }}>
            {financialDetailsList.map((fd) => (
              <>
                <RadioButton
                  name="financialDetails"
                  inputId={"financialDetails" + fd.code}
                  value={true}
                  onChange={(e) => {
                    console.log(e);
                    dispatch(setFinancialDetails(fd.code));
                    dispatch(setFinancialDetailsDesc(fd.descEng));
                  }}
                  checked={fd.code === financialDetails}
                />
                <label className="p-mr-5" htmlFor="isNrnYes">
                  {" "}
                  {getTValue(i18n, fd.descEng, fd.descNep)}
                </label>
              </>
            ))}
          </div>
          {/* <Controller
            name="financialDetails"
            control={control}
            rules={{ required: "Financial Details is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={financialDetails}
                onChange={(e) => {
                  console.log(e);
                  field.onChange(e.value);
                  dispatch(setFinancialDetails(e.value));
                  dispatch(
                    setFinancialDetailsDesc(
                      e.originalEvent.nativeEvent.target.ariaLabel
                    )
                  );
                }}
                options={financialDetailsList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectFinancialDetails")}
                optionValue="code"
              />
            )}
          /> */}
          <span style={{ color: "red" }}>{financialDetailsError}</span>
        </div>

        {getFormErrorMessage("financialDetails")}
        <div className="p-field p-col-12 p-md-12 ">
          <label
            className="p-col-12 p-md-12"
            htmlFor="securtitesTrading"
            style={{ textAlign: "center" }}
          >
            {t("securitiesTrading")}
          </label>
          <div
            className="p-grid p-field p-col-12 p-md-12"
            style={{ padding: 0, margin: 0 }}
          >
            <div
              className="p-field-radiobutton p-col-12 p-md-12"
              style={{ justifyContent: "center" }}
            >
              <Controller
                name="securtitesTrading"
                control={control}
                rules={{ required: "Securtites Trading is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={"Y"}
                    onChange={(e) => dispatch(setSecurtitesTrading(e.value))}
                    checked={securtitesTrading === "Y"}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xu")}
              </label>
              <Controller
                name="securtitesTrading"
                control={control}
                rules={{ required: "Securtites Trading is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={"N"}
                    onChange={(e) => dispatch(setSecurtitesTrading(e.value))}
                    checked={securtitesTrading === "N"}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label htmlFor="securitiesTradingNo">{t("xaina")}</label>
            </div>
          </div>
        </div>
        {getFormErrorMessage("securitiesTrading")}
        {securtitesTrading === "Y" ? (
          <>
            <div className="p-field p-col-12 p-md-6 stick-right">
              <label className="p-col-12 p-md-6" htmlFor="companyName">
                {t("companyName")}
              </label>
              <Controller
                name="companyName"
                control={control}
                rules={{ required: "Company Name is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("companyName")}
                    onChange={(e) => dispatch(setCompanyName(e.target.value))}
                    value={companyName}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
            </div>
            {getFormErrorMessage("companyName")}
            <div className="p-field p-col-12 p-md-6 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="companyDesgination">
                {t("designation")}
              </label>
              <Controller
                name="companyDesignation"
                control={control}
                rules={{ required: "Designation is required." }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    id={field.id}
                    value={companyDesignation}
                    filter showClear
                    disabled={loadingd}
                    dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                    onChange={(e) => {
                      dispatch(setCompanyDesignation(e.value));
                      field.onChange(e.value);
                      setCompDesignationDesc(
                        e.originalEvent.nativeEvent.target.ariaLabel
                      );
                      dispatch(
                        setCompanyDesignationDesc(
                          e.originalEvent.nativeEvent.target.ariaLabel
                        )
                      );
                      if (e.value !== "O") {
                        dispatch(setDesignationOthers(null));
                      }
                    }}
                    options={lookupDesignationList}
                    optionLabel={(data) =>
                      getTValue(i18n, data.descEng, data.descNep)
                    }
                    placeholder={t("selectDesignation")}
                    optionValue="code"
                  />
                )}
              />
            </div>
            {getFormErrorMessage("companyDesignation")}
            {companyDesignation === "O" ? (
              <>
                <div className="p-field p-col-12 p-md-4 stick-left">
                  <label
                    className="p-col-12 p-md-12"
                    htmlFor="designationOthers"
                  >
                    {t("designationOthers")}
                  </label>
                  <div className="p-inputgroup">
                    <Input
                      value={designationOthers}
                      onChange={(e) => {
                        dispatch(setDesignationOthers(e.target.value));
                      }}
                      placeholder={t("designationOthers")}
                    />
                  </div>
                </div>
              </>
            ) : null}
            <div className="p-col-12 p-md-12">
              <div className="p-grid">
                <div
                  className="p-col-12 p-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    onClick={(e) => {
                      console.log(companyName, companyDesignation);
                      let companyObj = {
                        companyName,
                        companyDesignation,
                        compDesignationDesc,
                        designationOthers,
                      };
                      if (!companyName || !companyDesignation) {
                        toast.warning("Message", "Company Name and Designation cannot be empty");

                        return;
                      }
                      const checkSameCompany = companyDetailsList.find(
                        (p) =>
                          p.companyName == companyName &&
                          p.companyDesignation == companyDesignation
                      );
                      if (checkSameCompany) {
                        toast.warning("Message", "Company Name and Designation must be different");

                        return;
                      }
                      dispatch(addCompanyDetails(companyObj));
                      dispatch(clearCompanyDetails());
                    }}
                    style={{ textAlign: "center" }}
                    className="add-button"
                  >
                    <i className="pi pi-plus">Add</i>{" "}
                  </Button>
                </div>
              </div>
              <DataTable value={companyDetailsList} dataKey="company">
                <Column field="companyName" header={t("companyName")}></Column>
                <Column
                  body={(rowData) => {
                    return (
                      rowData.designationOthers ? rowData.designationOthers :
                        (rowData.compDesignationDesc ||
                          rowData.companyDesignationDesc)
                      // getDescription(
                      //   lookupDesignationList,
                      //   rowData.companyDesignation
                      // )
                    );
                  }}
                  // field="compDesignationDesc"
                  header={t("designation")}
                ></Column>
                <Column
                  header={t("action")}
                  body={(rowData) => (
                    <i
                      className="pi pi-trash"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        //dispatch(removeCompanyDetails(rowData.companyName))
                        displayConfirmModal(rowData.companyName)
                      }
                    />
                  )}
                ></Column>
              </DataTable>
            </div>
          </>
        ) : (
          ""
        )}
        <>

          <div className="p-mt-3"></div>
          <div className="p-field p-col-12 p-md-12 ">
            <label
              className="p-col-12 p-md-12"
              htmlFor="securtitesTrading"
              style={{ textAlign: "center" }}
            >
              {t("securitiesTradingRelation")}
            </label></div>
          <div className="p-field p-col-12 p-md-6 stick-right">
            <label className="p-col-12 p-md-6" htmlFor="nameAndRelation">
              {t("nameAndRelation")}
            </label>
            <Controller
              name="nameAndRelation"
              control={control}
              rules={{ required: "Company or Relation is required." }}
              render={({ field, fieldState }) => (
                // <InputText
                //   id={field.name}
                //   {...field}
                //   isName
                //   keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                //   placeholder={t("nameAndRelation")}
                //   onChange={(e) => dispatch(setCompanyNameOrRelation(e.target.value))}
                //   value={companyNameOrRelation}
                //   className={classNames({ "p-invalid": fieldState.invalid })}
                // />
                <InputText
                  id={field.name}
                  {...field}
                  isName
                  keyfilter={/^[A-Za-z\s]+$/}
                  placeholder={t("nameAndRelation")}
                  onChange={(e) => dispatch(setCompanyNameOrRelation(e.target.value))}
                  onBlur={(e) => {
                    const value = e.target.value.trim(); // Trim to handle whitespace-only values
                    if (!value) {
                      dispatch(setCompanyNameOrRelationError({
                        message: "Name and Relation can't be empty.",
                        section: "OD",
                      }));
                    }
                    else if (!alphabetChecker(value)) {
                      dispatch(setCompanyNameOrRelationError({
                        message: "Name and Relation should be in alphabet characters only.",
                        section: "OD",
                      }));
                    }
                    else {
                      dispatch(setCompanyNameOrRelationError({
                        message: null,
                        section: "OD",
                      }));
                    }
                  }}
                  value={companyNameOrRelation}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <span style={{ color: "red" }}>{companyNameOrRelationError}</span>
          </div>
          {getFormErrorMessage("companyNameOrRelation")}
          <div className="p-field p-col-12 p-md-6 stick-left">
            <label className="p-col-12 p-md-12" htmlFor="companyName">
              {t("companyName")}*
            </label>
            <div className="p-inputgroup">
              {/* <InputText
                keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                clearSpace
                value={companyNameRelation}
                onChange={(e) => {
                  dispatch(setCompanyNameRelation(e.target.value));
                }}
                placeholder={t("cName")}
              /> */}
              <InputText
                keyfilter={/^[A-Za-z\s]+$/}
                clearSpace
                value={companyNameRelation}
                onChange={(e) => {
                  dispatch(setCompanyNameRelation(e.target.value));
                }}
                onBlur={(e) => {
                  const value = e.target.value.trim(); // Trim to handle whitespace-only values
                  if (!value) {
                    dispatch(setCompanyNameRelationError({
                      message: "Company Name can't be empty.",
                      section: "OD",
                    }));
                  }
                  else if (!alphabetChecker(value)) {
                    dispatch(setCompanyNameRelationError({
                      message: "Company Name should be in alphabet characters only.",
                      section: "OD",
                    }));
                  }
                  else {
                    dispatch(setCompanyNameRelationError({
                      message: null,
                      section: "OD",
                    }));
                  }
                }}
                placeholder={t("cName")}
              />
            </div>
            <span style={{ color: "red" }}>{companyNameRelationError}</span>
          </div>

          {/* Company Designation */}
          <div className="p-field p-col-12 p-md-6 stick-right">
            <label className="p-col-12 p-md-12" htmlFor="companyDesgination">
              {t("designation")}
            </label>
            <Controller
              name="companyRelationDesignation"
              control={control}
              rules={{ required: "Designation is required." }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.id}
                  value={companyRelationDesignation}
                  filter showClear
                  disabled={loadingd}
                  dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                  onChange={(e) => {
                    dispatch(setCompanyRelationDesignation(e.value));
                    field.onChange(e.value);
                    dispatch(
                      setCompanyRelationDesignationDesc(
                        e.originalEvent.nativeEvent.target.ariaLabel
                      )
                    );
                    if (e.value !== "O") {
                      dispatch(setRelationDesignationOthers(null));
                      dispatch(setRelationDesignationOthersError({ message: null, section: "OD", }));
                    }
                  }}
                  onBlur={(e) => {
                    const value = e.target.value.trim();
                    if (!value) {
                      dispatch(setCompanyRelationDesignationError({
                        message: "Company Relation Designation can't be empty.",
                        section: "OD",
                      }));
                    }
                    else if (!alphabetChecker(value)) {
                      dispatch(setCompanyRelationDesignationError({
                        message: "Company Relation Designation should be in alphabet characters only.",
                        section: "OD",
                      }));
                    }
                    else {
                      dispatch(setCompanyRelationDesignationError({
                        message: null,
                        section: "OD",
                      }));
                    }
                  }}
                  options={lookupDesignationList}
                  optionLabel={(data) =>
                    getTValue(i18n, data.descEng, data.descNep)
                  }
                  placeholder={t("selectDesignation")}
                  optionValue="code"
                // className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
          </div>
          {getFormErrorMessage("companyRelationDesignation")}
          {companyRelationDesignation === "O" ? (
            <>
              <div className="p-field p-col-12 p-md-6 stick-right">
                <label
                  className="p-col-12 p-md-6"
                  htmlFor="designationOthers"
                >
                  {t("designationOthers")}
                </label>
                {/* <Input
                  value={companyRelationDesignationOthers}
                  onChange={(e) => {
                    dispatch(setRelationDesignationOthers(e.target.value));
                  }}
                  placeholder={t("designationOthers")}
                /> */}
                <Input
                  value={companyRelationDesignationOthers}
                  keyfilter={/^[A-Za-z\s]+$/}
                  placeholder={t("designationOthers")}
                  onChange={(e) => {
                    dispatch(setRelationDesignationOthers(e.target.value));
                  }}
                  onBlur={(e) => {
                    const value = e.target.value.trim(); // Trim to handle whitespace-only values
                    if (!value) {
                      dispatch(setRelationDesignationOthersError({
                        message: "Designation can't be empty.",
                        section: "OD",
                      }));
                    } else if (!alphabetChecker(value)) {
                      dispatch(setRelationDesignationOthersError({
                        message: "Designation Others should be in alphabet characters only.",
                        section: "OD",
                      }));
                    } else {
                      dispatch(setRelationDesignationOthersError({
                        message: null,
                        section: "OD",
                      }));
                    }
                  }}
                />
              </div>
              <span style={{ color: "red" }}>
                {getFormErrorMessage("companyRelationDesignationOthers")}
              </span>
            </>
          ) : null}
          <div
            style={{ display: "flex" }}
            className="p-field p-col-12 p-md-6 stick-left">

            <AdBsDatePicker
              adError={dateError}
              bsStyle={
                { flex: 1 }
              }
              adStyle={
                { flex: 1 }
              }
              disableClassName={true}
              label={t("fromDate")}
              bsDate={fromAd ? adToBs(fromAd) : undefined}
              adDate={fromAd}
              onChange={(adDate, bsDate, extra) => {
                dispatch(setFromAD(adDate));
              }} />
          </div>

          <br />
          <div style={{
            display: "flex",
          }}
            className="p-field p-col-12 p-md-6 stick-right">
            <AdBsDatePicker
              bsStyle={
                { flex: 1 }
              }
              adStyle={
                { flex: 1 }
              }
              disableClassName={true}
              adError={dateError}
              label={t("toDate")}
              bsDate={toAd ? adToBs(toAd) : undefined}
              adDate={toAd}
              onChange={(adDate, bsDate, extra) => {

                dispatch(setToAD(adDate));
              }} />



          </div>
          <div className="p-col-12 p-md-12">
            <div className="p-grid">
              <div
                className="p-col-12 p-md-12"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  onClick={(e) => {
                    let companyObj = {
                      companyNameOrRelation,
                      companyNameRelation,
                      companyRelationDesignation,
                      fromAd,
                      toAd,
                      companyRelationDesignationDesc,
                      companyRelationDesignationOthers
                    };
                    if (!companyNameOrRelation || !companyNameRelation || !companyRelationDesignation || (!companyRelationDesignationOthers && companyRelationDesignation == "O")) {
                      toast.warning("Message", "Field cannot be empty.");
                      return;
                    }
                    // Validate fields with regex
                    const validationRegex = /^[A-Za-z\s]+$/;
                    if (!validationRegex.test(companyNameOrRelation)) {
                      toast.warning("Message", "Provide a valid Company Name or Relation in alphabet characters only.");
                      return;
                    }

                    if (!validationRegex.test(companyNameRelation)) {
                      toast.warning("Message", "Provide a valid Company Name Relation in alphabet characters only.");
                      return;
                    }

                    if (!validationRegex.test(companyRelationDesignationOthers)) {
                      toast.warning("Message", "Provide a valid Company Relation Others Designation in alphabet characters only.");
                      return;
                    }
                    if (!fromAd || !toAd) {
                      toast.warning("Message", "Date cannot be empty.");
                      return;
                    }
                    dispatch(addCompanyRelationDetails(companyObj));
                    dispatch(clearCompanyRelationDetails());
                  }}
                  style={{ textAlign: "center" }}
                  className="add-button"
                >
                  <i className="pi pi-plus">Add</i>{" "}
                </Button>
              </div>
            </div>
            <DataTable value={companyRelationDetailsList} dataKey="company">
              <Column field="companyNameOrRelation" header={t("nameAndRelation")}></Column>
              <Column field="companyNameRelation" header={t("companyName")}></Column>
              <Column
                body={(rowData) => {
                  return (
                    rowData.designationOthers ? rowData.designationOthers :
                      (rowData.companyRelationDesignationDesc ||
                        rowData.companyRelationDesignation)
                    // getDescription(
                    //   lookupDesignationList,
                    //   rowData.companyDesignation
                    // )
                  );
                }}
                // field="compDesignationDesc"
                header={t("designation")}
              ></Column>
              <Column field="fromAd" header={t("fromDate")}></Column>
              <Column field="toAd" header={t("toDate")}></Column>
              <Column
                header={t("action")}
                body={(rowData) => (
                  <i
                    className="pi pi-trash"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      displayConfirmModalRelation(rowData.companyNameOrRelation)
                      // dispatch(removeCompanyDetails(rowData.companyName))
                    }
                  />
                )}
              ></Column>
            </DataTable>
          </div>
        </>
      </div>
      <DynamicFieldSection />
    </Card>
  );
}

export default OccupationDetails;
